import { accessRole } from "../../../../../../helpers/access_role";
import { config } from "../../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/riwayatangkakreditService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../../services/apiResponse";

import moment from "moment";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  currentRoleId = JSON.parse(localStorage.getItem("currentRoleId"));

  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";

  source;
  historyTable = "admin";
  defaultOrder = "credit_score_create_date";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil di nonaktifkan";
  modal_confirm_error_message = "data gagal di nonaktifkan";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      pegawai_uuid: this.peg_uuid,
    };
    await this.dataTableBloc.fetchRowTableAdmin(query, this.source.token);
    // await this.dataTableBloc.fetchRowTable(query, this.source.token)
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          this.inactiveData();
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableAdminChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.activeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    this.dataTableBloc.rowtableAdminChannel?.unsubscribe();
  }

  columns = [
    {
      key: "credit_score_decree_number",
      text: "Nomor SK",
      className: "credit_score_decree_number",
      sortable: true,
      width: "20%",
    },
    {
      key: "employee_full_name",
      text: "Nama Pegawai",
      className: "employee_full_name",
      sortable: true,
      width: "20%",
    },
    {
      key: "employee_current_position_name",
      text: "Jabatan",
      className: "employee_current_position_name",
      sortable: true,
      width: "20%",
    },
    {
      key: "credit_score_primary",
      text: "Total Kredit Baru",
      className: "credit_score_primary",
      sortable: true,
      cell: (record) => {
        var total =
          parseFloat(record.credit_score_primary) +
          parseFloat(record.credit_score_secondary);
        return <span>{<label>{total}</label>}</span>;
      },
    },
    {
      key: "credit_score_month_start",
      text: "Bulan Mulai Penilaian",
      className: "credit_score_month_start",
      sortable: true,
      width: "20%",
    },
    {
      key: "credit_score_decree_date",
      text: "Tanggal SK",
      className: "credit_score_decree_date",
      sortable: true,
      width: "20%",
      cell: (record) => {
        return this.dateParse(record.credit_score_decree_date);
      },
    },
    {
      key: "credit_score_month_end",
      text: "Bulan Selesai Penilaian",
      className: "credit_score_month_end",
      sortable: true,
      width: "20%",
    },
    {
      key: "credit_score_year_start",
      text: "Tahun Mulai Penilaian",
      className: "credit_score_year_start",
      sortable: true,
      width: "20%",
    },
    {
      key: "credit_score_primary",
      text: "Kredit Utama Baru",
      className: "credit_score_primary",
      sortable: true,
      width: "20%",
    },
    {
      key: "credit_score_year_end",
      text: "Tahun Selesai Penilaian",
      className: "credit_score_year_end",
      sortable: true,
      width: "20%",
    },
    {
      key: "credit_score_secondary",
      text: "Kredit Penunjang Baru",
      className: "credit_score_secondary",
      sortable: true,
      width: "20%",
    },
    // {
    //     key: "position_history_status",
    //     text: "Status",
    //     className: "position_history_status",
    //     sortable: true,
    //     cell: record => {
    //         var  status = record.position_history_status
    //         return (
    //             <span>
    //                 { parseInt(status) == 1 ? <label className="badge rounded-pill bg-soft-success font-size-12" >Aktif</label>: <label><label className="badge rounded-pill bg-soft-danger font-size-12" >Tidak Aktif</label></label> }
    //             </span>
    //         )
    //     }
    // },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.credit_score_uuid;
        var status = record.credit_score_status;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.credit_score_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
            <span>
              <button
                className="btn btn-success btn-sm"
                id={"approve-" + thisId}
                onClick={() => {
                  this.setState({
                    updateUuid: record.credit_score_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-check"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["approve" + thisId]}
                target={"approve-" + thisId}
                toggle={() => {
                  this.setState({
                    ["approve" + thisId]: !this.state["approve" + thisId],
                  });
                }}
              >
                Approve
              </Tooltip>
            </span>
            {/* <span>
                        <button 
                            className="btn btn-danger btn-sm" 
                            id={"delete-" + thisId}
                            onClick={() => {
                                this.modal_confirm_status = 1
                                this.modal_confirm_message = "Apakah anda yakin akan menonaktifkan data ini ?"
                                this.setState({
                                    inactiveUuid: record.credit_score_uuid,
                                    confirm: true
                                })
                            }}
                            style={{
                                padding: '2px 5px'
                            }}>
                            <i className="uil-trash-alt"></i>
                        </button>
                        <Tooltip
                            style={{
                                marginBottom: 2
                            }}
                            placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                            toggle={() => {
                                this.setState({
                                    ["delete" + thisId] : !this.state["delete" + thisId]
                                })
                            }}
                        >Nonaktifkan
                        </Tooltip>
                        </span> */}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/riwayat_angkakredit.html?detail&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/riwayat_angkakredit.html?approve&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
